import React, { memo, useEffect } from 'react';
import { SegmentedFacetOption } from '../types';

export interface SegmentedFacetToggleProps {
  options: SegmentedFacetOption[];
  activeKey: string;
  onChange: (key: string) => void;
  /** Accessible name for the toggle group, e.g. "Fulfillment type". */
  groupLabel?: string;
}

const SegmentedFacetToggleComponent: React.FC<SegmentedFacetToggleProps> = memo(
  ({ options, activeKey, onChange, groupLabel }: SegmentedFacetToggleProps) => {
    useEffect(() => {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('segmented-facet-toggle.ready');
    }, []);

    return (
      <div className="sui-flex sui-items-center" role="group" aria-label={groupLabel}>
        {options.map((option) => {
          const isActive = option.key === activeKey;
          return (
            <button
              key={option.key}
              type="button"
              aria-pressed={isActive}
              onClick={() => onChange(option.key)}
              className={
                isActive
                  ? 'sui-rounded-base sui-border-0 sui-bg-inverse sui-px-3 sui-py-2 sui-text-sm sui-font-bold sui-text-inverse'
                  : 'sui-rounded-base sui-border-1 sui-border-solid sui-border-strong sui-px-3 sui-py-2 sui-text-sm sui-text-subtle hover:sui-bg-subtle'
              }
            >
              {option.label} ({option.count})
            </button>
          );
        })}
      </div>
    );
  }
);

SegmentedFacetToggleComponent.displayName = 'SegmentedFacetToggle';

const SegmentedFacetToggle = SegmentedFacetToggleComponent;

export { SegmentedFacetToggle };
